// extracted by mini-css-extract-plugin
export var body = "lcSearchResults-module--body--a4581";
export var breadcrumbs = "lcSearchResults-module--breadcrumbs--2db40";
export var container = "lcSearchResults-module--container--a2394";
export var hit = "lcSearchResults-module--hit--ea8ad";
export var hits = "lcSearchResults-module--hits--5df9d";
export var link = "lcSearchResults-module--link--9b44b";
export var noResults = "lcSearchResults-module--noResults--1606c";
export var noScroll = "lcSearchResults-module--no-scroll--79c6f";
export var title = "lcSearchResults-module--title--170fc";